import { Loan } from 'v2-types/order';

type LoanRef = Pick<Loan, '_id' | 'loan_number'>;

/**
 * The created loan is the one whose id did not exist before the mutation.
 * Falls back to a non-empty loan number match, then to the last loan returned.
 */
export const resolveCreatedLoanId = (
  previousLoanIds: string[],
  loans: LoanRef[],
  loanNumber?: string | null
): string | undefined => {
  const created = loans.find((loan) => !previousLoanIds.includes(loan._id));
  if (created) return created._id;

  if (loanNumber) {
    const byNumber = loans.find((loan) => loan.loan_number === loanNumber);
    if (byNumber) return byNumber._id;
  }

  return loans[loans.length - 1]?._id;
};

/**
 * Absolute path to a loan inside the order. A relative push (`history.push(id)`) from
 * `/orders/details/:id/loans` (no loan selected yet) replaced the `loans` segment and
 * produced an unrouted URL — the blank screen of TP-6408.
 */
export const buildLoanPath = (pathname: string, loanId: string): string => {
  if (/\/loans(\/|$)/.test(pathname)) {
    return pathname.replace(/\/loans.*$/, `/loans/${loanId}`);
  }
  return `${pathname.replace(/\/+$/, '')}/loans/${loanId}`;
};
